import { GraphQLRequestClient } from '@sitecore-jss/sitecore-jss-nextjs/graphql';
import {
  PressReleaseSearchDocument,
  PressReleaseSearchQuery,
} from 'lib/services/queries/PressReleaseSearch.graphql';
import {
  PressReleaseDataDocument,
  PressReleaseDataQuery,
  PressReleaseDataQueryVariables,
} from 'lib/services/queries/PressReleaseData.graphql';
import {
  PressReleaseSearchLatestDocument,
  PressReleaseSearchLatestQuery,
} from 'lib/services/queries/LatestPressReleasesSection.graphql';
import graphqlClientFactory from 'lib/graphql-client-factory';
import { PressReleaseData } from 'model/PressReleases';

class PressReleaseService {
  constructor(private readonly graphQLClient: GraphQLRequestClient) {}

  public async getPressReleaseLayout(pressReleaseName: string, siteId: string, language: string) {
    const queryParams = {
      pageSize: 1,
      pageHash: '',
      pressReleaseName,
      language,
      siteId,
    };
    const result = await this.graphQLClient.request<PressReleaseSearchQuery>(
      PressReleaseSearchDocument,
      queryParams
    );
    return result.search?.results[0];
  }

  public async getPressReleaseData(
    id: string,
    language: string
  ): Promise<PressReleaseData | undefined> {
    const queryParams: PressReleaseDataQueryVariables = { path: id, language };
    const result = await this.graphQLClient.request<PressReleaseDataQuery>(
      PressReleaseDataDocument,
      queryParams
    );

    return result.item as PressReleaseData;
  }

  public async getLatestPressReleases(
    language: string,
    siteId: string
  ): Promise<PressReleaseData[]> {
    const queryParams = { siteId, language, pageSize: 5 };
    const result = await this.graphQLClient.request<PressReleaseSearchLatestQuery>(
      PressReleaseSearchLatestDocument,
      queryParams
    );
    return (result?.search?.results as PressReleaseData[]) ?? [];
  }
}

export const pressReleaseService = new PressReleaseService(graphqlClientFactory());
